<template lang="pug">
ul.nav(v-if="menus")
	//- li.nav-header Navigation
	template(v-for="menu in menus")
		sidebar-nav-list(
			ref="sidebarNavList"
			:menu="menu"
			:scroll-top="scrollTop"
			:key="menu.path"
			:status="menu.status"
			@collapse-other="handleCollapseOther(menu)"
			@showFloatSubmenu="handleShowFloatSubmenu"
			@hideFloatSubmenu="handleHideFloatSubmenu"
		)
	//- li
	//- 	a.sidebar-minify-btn(href="#" @click="handleSidebarMinify()")
	//- 		i.fa.fa-angle-double-left
</template>

<script>
import SidebarMenu from './SidebarMenu.vue'
import SidebarNavList from './SidebarNavList.vue'
import PageOptions from '../../config/PageOptions.vue'

export default {
	name: 'SidebarNav',
	components: {
		SidebarNavList
	},
	props: ['scrollTop'],
	data () {
		return {
			menus: SidebarMenu,
			pageOptions: PageOptions
		}
	},
	methods: {
		handleShowFloatSubmenu: function(menu, offset) {
			this.$emit('showFloatSubmenu', menu, offset);
		},
		handleHideFloatSubmenu: function() {
			this.$emit('hideFloatSubmenu');
		},
		handleCollapseOther: function(menu) {
			for (var i = 0; i < this.menus.length; i++) {
				this.$refs.sidebarNavList[i].collapse(menu);
			}
		},
		handleSidebarMinify: function() {
			this.pageOptions.pageSidebarMinified = !this.pageOptions.pageSidebarMinified;
		}
	}
}
</script>
